import type { CycleOperatorSummary } from "./types";

export function summarizeBundle5ShadowLine(cycle?: CycleOperatorSummary | null): string | null {
  const b = cycle?.bundle5Shadow;
  if (!b) return null;
  const deduped = b.wouldBlockDeduped ?? 0;
  const gate = b.gateMin ?? 30;
  return `bundle-5 regime throttle shadow ${deduped}/${gate}`;
}
